// Single monotonic progress-bar model for the whole checkout flow, so no step hardcodes a
// number. Values only ever increase across the real screen sequence. Signup interpolates
// between SIGNUP_START and SIGNUP_END across its sub-steps.
export const CHECKOUT_PROGRESS = {
  INSTALLMENT_PREVIEW: 10,
  SIGNUP_START: 20,
  SIGNUP_END: 64,
  UNDERWRITING: 70,
  IDV: 80,
  PAYMENT: 90,
  CONFIRMATION: 96,
  COMPLETE: 100,
} as const
